import { connect } from 'react-redux';
import { isLoading } from 'helpers';
import {
  loadMaCompetenciesCreator,
  setMaCompetenciesPageCreator,
  setMaCompetenciesPerPageCreator,
  setMaCompetenciesSortCreator,
  setMaCompetenciesFiltersCreator,
} from '../../../../store/actionsCreators';
import Competencies from '../../../../shared/Cpd/Competencies/Competencies';

const mapStateToProps = ({ loading, ma }) => ({
  loading: isLoading(loading, 'LOAD_MA_COMPETENCIES'),
  list: ma.competencies,
});

const mapDispatchToProps = (dispatch) => ({
  loadList: () => dispatch(loadMaCompetenciesCreator()),
  setPage: (payload) => dispatch(setMaCompetenciesPageCreator(payload)),
  setPerPage: (payload) => dispatch(setMaCompetenciesPerPageCreator(payload)),
  setSort: (payload) => dispatch(setMaCompetenciesSortCreator(payload)),
  setFilters: (payload) => dispatch(setMaCompetenciesFiltersCreator(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Competencies);
